import './style.scss';

import PlatformIcon from 'shared/components/PlatformIcon';
import { useTypedSelector } from 'store';
import { ICexPair, IDexPair } from 'types/pairs';
import { Checkbox } from 'ui/Checkbox/Checkbox';

interface PairsListProps {
  type: 'dex' | 'cex';
  toggleAllPairs: () => void;
  selectedPairs: (ICexPair | IDexPair)[];
  pairs: (ICexPair | IDexPair)[];
  handlePairSelect: (pair: ICexPair | IDexPair) => void;
}

const PairsList: React.FC<PairsListProps> = ({
  type,
  toggleAllPairs,
  selectedPairs,
  pairs,
  handlePairSelect,
}) => {
  const isAdmin = useTypedSelector(store => store.auth.isAdmin);

  const isAllSelected = selectedPairs.length === pairs.length;

  return (
    <div className="mm-add-arbitrage-modal__pairs-list-wrapper">
      <div className="pairs-list-title">
        {isAdmin ? (
          <button className="all-pairs-button" onClick={toggleAllPairs}>
            {isAllSelected
              ? `Unselect all ${type.toUpperCase()} pairs`
              : `Select all ${type.toUpperCase()} pairs`}
          </button>
        ) : (
          <span>All pairs:</span>
        )}
        <span className="selected-number">Selected: {selectedPairs.length}</span>
      </div>
      {pairs.length === 0 && (
        <div className="not-found">
          <span>
            No {type.toUpperCase()} pairs found to add.{' '}
            {type === 'cex' ? 'You can press continue to add DEX pairs' : ''}
          </span>
        </div>
      )}
      {pairs.length !== 0 && (
        <div className="pairs-list">
          {pairs.map(pair => (
            <div
              key={pair.created_at}
              className="trading-pair"
              onClick={() => handlePairSelect(pair)}
            >
              <Checkbox
                className="checkbox"
                checked={selectedPairs.some(selected => selected.id === pair.id)}
                onChange={() => handlePairSelect(pair)}
              />
              <div className="trading-pair-content">
                <PlatformIcon
                  platform={'dex' in pair ? pair.dex : pair.cex}
                  isIcon
                  className="mm-sidebar__projects__project__trading-pair-icon"
                />
                <span>{pair.symbol}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export { PairsList };
